/**
 * @typedef {Object} GlobalSearchResultDto
 * @property {string} category - 'ORDER' | 'COMPONENT' | 'WIP'
 * @property {number} id
 * @property {string} title
 * @property {string} subtitle
 * @property {string} [statusCode]
 */

const BASE_PATH = 'v1/Search';

export default function (instance) {
  return {
    /**
     * Search production orders, components, and WIP items by a free-text term.
     * @param {string} q
     * @returns {Promise<{data: GlobalSearchResultDto[]}>}
     */
    search(q) {
      return instance.get(BASE_PATH, { params: { q } });
    }
  };
}
